/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { Link } from 'react-router-dom'

/**
 *     Import
 *     - Components
 */
import Container from '../../common/Container/Container'
import HeaderContainer from '../../common/HeaderContainer/HeaderContainer'
import ClientsTableHeader from './components/ClientsTableHeader'
import { ViewIcon } from '../../../images/icons/View/View'
// import { TickIcon } from '../../../images/icons/Tick/Tick'
import ToolTip from '../../common/ToolTip/ToolTip'
import { Button } from '../../common/Button/Button'
import Loading from '../../common/Loading/Loading'
import PopUp from '../../common/PopUp/PopUp'
import { currency } from '../../common/CurrencyFormat'
// import axios from "axios"
/**
 *     Import
 *     - CSS
 */
import './styles/Accounts.css'

/**
 * Accounts section class
 *
 * @export
 * @class Accounts
 * @extends {React.Component<any, any>}
 * 
 */
const minOffset = 0
const maxOffset = 60
const FutureminOffset = -25
const FuturemaxOffset = 0
// const Promise = require('axios');
// const requestHelper = {
//     appendHeaders(request){
//       request.headers = request.headers || {};
//       if(request.headers["Content-Type"]){
//         return
//       }
//       request.headers["Content-Type"] = "application/json";
//     },
//     externalApi(request, serverResult){
//       if(!request.method){
//         request.method='POST';
//       }
//       request.path = request.url
//       this.appendHeaders(request)
//      console.log('request',request)
//       return Promise(request)
//       .then((apiResponse) => {
//         if (apiResponse.data.errors) {
//           var error = apiResponse.data.errors;
//           console.log('api error response: ', error);
//           serverResult.status(400).json({ error })
//         } else {
//           console.log('api response: ', apiResponse.data);
//           serverResult.status(200).json(apiResponse.data);
//         }
//       }).catch((error) => {
//         console.log('api error response: ', error);
//         serverResult.status(400).json({ error });
//       });
//      },

//      getDownloadResponse(request, serverResult){
//       debugger;
//       request.path = request.url
//       this.appendHeaders(request)
//       console.log(request);
//       return Promise(request)
//       .then((apiResponse) => {
//         if (apiResponse.data.errors) {
//           var error = apiResponse.data.errors;
//           console.log('api error response: ', error);
//           serverResult.status(400).json({ error })
//         } else {
//           serverResult.status(200);
//           console.log('api response status: '+200);
//         }
//       }).catch((error) => {
//         console.log('api error response: ', error);
//         serverResult.status(400).json({ error });
//       });
//      }
//   };

export default class Accounts extends React.Component<any, any> {

    /**
     * Creates an instance of Clients.
     * @param {*} props
     * @memberof Clients
     */
    constructor(props: any) {
        super(props)
        const thisYear = (new Date()).getFullYear()
        const thisDay = (new Date()).getDate()
        const thisMonth = (new Date()).getMonth()
        this.state = {
            bodereux: false,
            thisYear: thisYear,
            selectedFromYear: thisYear,
            selectedFromDay: thisDay,
            selectedFromMonth: thisMonth,
            selectedToYear: thisYear,
            selectedToDay: thisDay,
            selectedToMonth: thisMonth,
            filters: {
                page: 1,
                perPage: 20,
                sortedBy: 'clientName',
                sortedType: 'asc',
            },
            confirmDeleteEntry: false,
            DeleteId: null,
        }
    }

    /**
     * Will check the URL before the component mounts and will redirect
     * to the correct site of the application
     *
     * @memberof Clients
     */
    componentWillMount() {
        this.props.fetchAccountList()
    }

    componentWillUpdate(nextProps: any, nextState: any) {
        if (this.state.filters !== nextState.filters) {
            this.props.fetchAccountList(
                nextState.filters.page,
                nextState.filters.perPage,
                nextState.filters.sortedBy,
                nextState.filters.sortedType
            )
        }
    }

    /**
     * Will handle the footer click for more data loading
     *
     * @memberof Clients
     */
    handleFooterClick = () => {
        this.setState({ filters: { perPage: this.state.filters.perPage + 20 } })
    }

    bordereux = () => {
        this.setState({ bodereux: true })
    }
    okBordereux = () => {
        this.setState({ bodereux: false })
        let bordereaux: any = {
            'bordereaux': {
                'from_date': {
                    'day': this.state.selectedFromDay,
                    'month': this.state.selectedFromMonth,
                    'year': this.state.selectedFromYear,
                },
                'to_date': {
                    'day': this.state.selectedToDay,
                    'month': this.state.selectedToMonth,
                    'year': this.state.selectedToYear,
                },
            },
        }
        // requestHelper.externalApi
        // console.log(bordereaux)
        this.props.generateborderaux(bordereaux)
        // if(this.props.generateborderaux(bordereaux)){
        //    fetch(this.props.generateborderaux(bordereaux)).then(results => {
        //        console.log(results.json())
        //        return results.json()

        //    })
        // }
        // axios.get(this.props.generateborderaux(bordereaux))
        // .then(function(res){
        //   console.log(res)
        // })
        // .catch(function(e) {
        //   console.log("ERROR ", e)
        // })
        // fake server request, getting the file url as response
        // setTimeout(() => {
        //     const response = {
        //         file: this.props.generateborderaux(bordereaux),
        //     };
        //     // server sent the url to the file!
        //     // now, let's download:
        //     window.open(response.file);
        //     // you could also do:
        //     // window.location.href = response.file;
        // }, 100);
    }
    // download() {
    //     // fake server request, getting the file url as response
    //     setTimeout(() => {
    //         const response = {
    //             file: '',
    //         };
    //         // server sent the url to the file!
    //         // now, let's download:
    //         window.open(response.file);
    //         // you could also do:
    //         // window.location.href = response.file;
    //     }, 100);
    // }
    cancelBordereux = () => {
        this.setState({ bodereux: false })
    }
    onFromChange = (evt, which) => {
        // Handle Change Here
        // alert(evt.target.value);
        // console.log(evt.target.value, which)
        switch (which) {
            case 'yr':
                this.setState({ selectedFromYear: Number(evt.target.value) })
                break

            case 'month':
                this.setState({ selectedFromMonth: Number(evt.target.value) })
                break

            case 'day':
                this.setState({ selectedFromDay: Number(evt.target.value) })
                break

            default:
                break
        }
    }
    onToChange = (evt, which) => {
        // Handle Change Here
        // alert(evt.target.value);
        switch (which) {
            case 'yr':
                this.setState({ selectedToYear: Number(evt.target.value) })
                break

            case 'month':
                this.setState({ selectedToMonth: Number(evt.target.value) })
                break

            case 'day':
                this.setState({ selectedToDay: Number(evt.target.value) })
                break

            default:
                break
        }
    }

    /**
     * Trigger fot the header filters
     *
     * @memberof Clients
     * @param {Object} params
     */
    filterTrigger = (params: any) => this.setState(
        {
            filters: {
                page: this.state.filters.page,
                perPage: this.state.filters.perPage,
                sortedBy: params.sortedBy,
                sortedType: params.sortedType,
            },
        }
    )

    markAsPaid = (paidId: any) => {
        this.props.mark_as_paid(paidId).then((response) => {
            if (response) {
                this.forceUpdate()
            }
        })
    }

    deleteEntry = (deleteId: any) => {
        this.setState({ confirmDeleteEntry: true, DeleteId: deleteId })
    }

    confirmDelete = () => {
        if (this.state.DeleteId) {
            this.props.remove_entry(this.state.DeleteId).then((response) => {
                if (response) {
                    this.forceUpdate()
                }
            }
            )
            this.setState({ confirmDeleteEntry: false })
        }
    }

    render() {

        let quotesCount = (this.props.accounts.accounts.done) ? this.props.accounts.accounts.response.totalNumber : 0
        const { thisYear } = this.state
        // let selectedToYear = this.state.selectedToYear
        // let selectedFromYear = this.state.selectedFromYear
        const Yearoptions: any = []
        const FutureYearoptions: any = []
        let MonthOptions: any = []
        let DayOptions: any = []
        let monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
            'August', 'September', 'October', 'November', 'December']
        let startMonth = 1
        // this.setState({
        //     selectedYear:selectedYear
        // })

        for (let i = minOffset; i <= maxOffset; i++) {
            const year = thisYear - i
            let opt = <option value={year}>{year}</option>
            Yearoptions.push(opt)
        }
        for (let i = FuturemaxOffset; i >= FutureminOffset; i--) {
            const year = thisYear - i
            let opt = <option value={year}>{year}</option>
            FutureYearoptions.push(opt)
        }
        for (let j = startMonth; j <= 12; j++) {
            let opt = <option value={j}> {monthNames[j - 1]} </option>
            MonthOptions.push(opt)
        }
        for (let k = 1; k <= 31; k++) {
            let opt = <option value={k}>{k}</option>
            DayOptions.push(opt)
        }
        return (
            <div className="accounts">
                <HeaderContainer
                    className="accounts__header"
                    fullwidth={true}
                    titles={['accounts']}
                >
                    <div className="generate-statement">
                        <a href="https://underwriter.virtusolutions.co.uk/api/v1/accounts/generate_statement">
                            GENERATE STATEMENT OF ACCOUNTS
                        </a>
                    </div>
                    <div className="bar__getquote generate_bordereux">
                        {(this.props.userSession.agentAdmin) ?
                            <a onClick={() => this.bordereux()}>
                                <span style={{ backgroundColor: '#F07662' }}>
                                    Generate bordereau
                                </span>
                            </a> : null}
                        <div className="policyCount">
                            {`${quotesCount} ${(quotesCount === 1) ? 'policy' : 'policies'} due for payment`}
                        </div>
                    </div>

                </HeaderContainer>
                <ClientsTableHeader
                    state={this.state}
                    dataType={this.state.typeSelected}
                    filterTrigger={this.filterTrigger}
                />
                {
                    (this.state.bodereux) ?
                        < PopUp
                            title="Generate Bordereau"
                            buttonText="Export Bordereau"
                            action={this.okBordereux}
                            numberButtons={2}
                            secondaryButtonText="Cancel"
                            secondaryAction={this.cancelBordereux}
                        >
                            <p>Please select the dates for which you wish to generate bordereau</p>
                            <form className="boderaux_form">

                                <div className="boderaux_form_group">
                                    <h4 className="boderaux_title">From</h4>
                                    <div className="boderaux_filed">
                                        <label className="boderaux_label">Day</label>
                                        <select
                                            className="boderaux_select"
                                            // value={this.state.selectedFromDay}
                                            onChange={(e) => this.onFromChange(e, 'day')}
                                        >
                                            {DayOptions}
                                        </select>
                                    </div>
                                    <div className="boderaux_filed">
                                        <label className="boderaux_label">Month</label>
                                        <select
                                            className="boderaux_select"
                                            // value={this.state.selectedFromMonth}
                                            onChange={(e) => this.onFromChange(e, 'month')}
                                        >
                                            {MonthOptions}
                                        </select>
                                    </div>
                                    <div className="boderaux_filed">
                                        <label className="boderaux_label">Year</label>
                                        <select
                                            className="boderaux_select"
                                            // value={selectedFromYear}
                                            onChange={(e) => this.onFromChange(e, 'yr')}
                                        >
                                            {Yearoptions}
                                        </select>
                                    </div>

                                </div>

                                <div className="boderaux_form_group">
                                    <h4 className="boderaux_title">To</h4>
                                    <div className="boderaux_filed">
                                        <label className="boderaux_label">Day</label>
                                        <select
                                            className="boderaux_select"
                                            // value={this.state.selectedToDay}
                                            onChange={(e) => this.onToChange(e, 'day')}
                                        >
                                            {DayOptions}
                                        </select>
                                    </div>
                                    <div className="boderaux_filed">
                                        <label className="boderaux_label">Month</label>
                                        <select
                                            className="boderaux_select"
                                            // value={this.state.selectedToMonth}
                                            onChange={(e) => this.onToChange(e, 'month')}
                                        >
                                            {MonthOptions}
                                        </select>
                                    </div>
                                    <div className="boderaux_filed">
                                        <label className="boderaux_label">Year</label>
                                        <select
                                            className="boderaux_select"
                                            // value={selectedToYear}
                                            onChange={(e) => this.onToChange(e, 'yr')}
                                        >
                                            {FutureYearoptions}
                                        </select>
                                    </div>

                                </div>
                            </form>
                        </ PopUp>
                        :
                        null
                }
                {(this.state.confirmDeleteEntry) ?
                    < PopUp
                        title="Confirm"
                        buttonText="Yes"
                        action={this.confirmDelete}
                        numberButtons={2}
                        secondaryButtonText="Cancel"
                        secondaryAction={() => this.setState({ confirmDeleteEntry: false })}
                    >
                        Are you sure?
                    </ PopUp> :
                    null}
                <Container className="accounts accounts__table table__content" fullwidth={false}>
                    {
                        (this.props.accounts.accounts.done &&
                            this.props.accounts.accounts.response.accounts.map((quote: any, i: number) => (
                                <div key={i}>
                                    <div className="table__row">
                                        <div className="column" />
                                        <div className="column no-margin">{quote.clientName}</div>
                                        <div className="column">{quote.inceptionDate}</div>
                                        <div className="column">{quote.policyNumber}</div>
                                        <div className="column">{currency(quote.premium)}</div>
                                        <div className="column center">
                                            {(quote.paid) ?
                                                <div onClick={() => this.markAsPaid(quote.id)}>
                                                    <ToolTip
                                                        position="left"
                                                        verticalPosition="top"
                                                        Accounts={true}
                                                        AccountsBin={false}
                                                        paid={true}
                                                    >
                                                        Mark as not paid
                                                    </ToolTip>
                                                </div>
                                                :
                                                <div onClick={() => this.markAsPaid(quote.id)}>
                                                    <ToolTip
                                                        position="left"
                                                        verticalPosition="top"
                                                        Accounts={true}
                                                        AccountsBin={false}
                                                        paid={false}
                                                    >
                                                        Mark as paid
                                                    </ToolTip>
                                                </div>
                                            }
                                            {(quote.paid) ?
                                                <div onClick={() => this.deleteEntry(quote.id)}>
                                                    <ToolTip
                                                        position="left"
                                                        verticalPosition="top"
                                                        Accounts={true}
                                                        AccountsBin={true}
                                                    >
                                                        Remove from bordereaux
                                                    </ToolTip>
                                                </div>
                                                :
                                                <div>
                                                    <ToolTip
                                                        position="left"
                                                        verticalPosition="top"
                                                        Accounts={true}
                                                        AccountsBin={true}
                                                    >
                                                        Remove from bordereaux
                                                    </ToolTip>
                                                </div>}
                                            <div>
                                                <Link to={`/clients/policies/view/${quote.policyId}`}>
                                                    <ViewIcon />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                            ))
                    }
                </Container>
                <div className="accounts__footer">
                    <div className="accounts__footer--brick" >
                        {
                            (this.props.accounts.accounts.loading) ?
                                <Loading />
                                :
                                <Button type="submit" onClick={this.handleFooterClick}>Load more</Button>
                        }
                    </div>
                </div>
            </div >
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Accounts/Accounts.tsx